import { api, ReactQueryOptions, RouterInputs } from '@api'
import { useSession } from '@shared/hooks/useSession'

type optionsType = ReactQueryOptions['UserManager']['getCollectedToyInstances']
type inputType = RouterInputs['UserManager']['getCollectedToyInstances']

export const useGetCollectedToyInstances = (input: inputType, options?: optionsType) => {
    const { status } = useSession()
    return api.UserManager.getCollectedToyInstances.useQuery(input, {
        ...options,
        queryKey: ['UserManager.getCollectedToyInstances', input],
        enabled: status === 'authenticated' && options?.enabled,
        staleTime: 30 * 1000, // 30 sec
    })
}
